import {Api} from "../api/api";

class CommentDeleteButtons
{
    constructor(buttons) {
        this.buttons = buttons;

        this.initListeners();
    }

    initListeners() {
        Array.from(this.buttons).forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();

                Api.post(
                    element.getAttribute('data-endpoint'),
                    {comment_id: element.getAttribute('data-comment-id')},
                    (response) => {
                        let reload = response.get('reload');

                        if (reload) {
                            window.location.reload(true);
                        } else {
                            element.closest('.comments-list-item').remove();
                        }
                    }
                );
            });
        });
    }
}

export {CommentDeleteButtons};
